import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
//import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
//import Hidden from '@material-ui/core/Hidden';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LaunchIcon from '@material-ui/icons/Launch';
import UpdateIcon from '@material-ui/icons/Update';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import Switch from '@material-ui/core/Switch';
import PersonIcon from '@material-ui/icons/Person';

import red from '@material-ui/core/colors/red'

import { formatEnquiry } from '../../helpers'
import OfficePageStyles from '../../styles/OfficePage';

import OfficeDataTab from './OfficeDataTab'
import PricingTab from './PricingTab'
import GalleryTab from './GalleryTab'

import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import * as API from '../../utils/api'

const CustomTableCell = withStyles(theme => ({
  body: {
    borderBottomColor: 'transparent',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit
  }
}))(TableCell);

class OfficePage extends Component {
	state = {
    tab: 0,
    //office: {},
    redirect: false
  }

  componentDidMount () {
    const { id, accountId, office } = this.props

    /*API.getOffice(id)
      .then((office) => {
        this.setState(() => ({
          statusId: office.statusId,
          office,
          //redirect: office.accountId !== accountId ? true : false
        }))
      })*/
  }

  handleTabToggle = (event, tab) => {
    this.setState({ tab });
  }

  handleRefreshData = () => {
    const { id } = this.props

    //console.log('refreshed')

    API.getOffice(id)
      .then((office) => {
        this.setState(() => ({
          office,
        }))
      })
  }

	render() {
		const { history, classes, officeEnquiries, id, packets, office } = this.props
    const { redirect, tab } = this.state
    //const packets = office.packets ? office.packets : null
    const contacts = office.contacts ? office.contacts : null

		//console.log('Packets: ', packets)

    if (redirect) {
      return <Redirect to='/offices' />
    }

		return (
			<div style={{ backgroundColor: '#fff', height: '100vh' }}>
        <AppBar className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            {history.length > 2
              ? (<IconButton color="inherit" onClick={history.goBack}>
                  <KeyboardBackspaceIcon />
                </IconButton>)
              : (<Link to='/offices'>
                  <IconButton color="inherit">
                    <KeyboardBackspaceIcon />
                  </IconButton>
                </Link>)
            }
            <Typography variant="title" color="inherit" className='enquiry-title'>
              {office.name}
            </Typography>
          </Toolbar>
        </AppBar>

        <div className={classes.topContainer}>
          <Grid container spacing={0} direction={'row'} alignItems={'stretch'}>
            {office.photo && (
              <Grid item xs={12} sm={6} md={5}>
                <div className={classes.imageHeader} style={{ backgroundImage: `url(${office.photo})` }}></div>
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={7} className="pa-1">
              <Grid container spacing={24}>
                <Grid item xs={4} sm={2}>
                  <Typography variant="headline" gutterBottom>{office.totalArea}</Typography>
                  <Typography variant="caption">Total area</Typography>
                </Grid>
                <Grid item xs={4} sm={2}>
                  <Typography variant="headline" gutterBottom>{office.workStations}</Typography>
                  <Typography variant="caption">Work stations</Typography>
                </Grid>
                <Grid item xs={4} sm={2}>
                  <Typography variant="headline" gutterBottom>{office.availability}</Typography>
                  <Typography variant="caption">Availability</Typography>
                </Grid>
                <Grid item xs={2} sm={2} className='xs-hidden'>
                  <Typography variant="headline" gutterBottom>{office.views}</Typography>
                  <Typography variant="caption">Views</Typography>
                </Grid>
                <Grid item xs={2} sm={2} className='xs-hidden'>
                  <Typography variant="headline" gutterBottom>{office.enquiriesCount}</Typography>
                  <Typography variant="caption">Enquiries</Typography>
                </Grid>
              </Grid>

              <Typography variant="headline" style={{ marginTop: '50px', fontSize: '0.85rem', lineHeight: '1.5rem', display: 'flex' }}>
                <LocationOnIcon style={{ color: '#414042', marginRight: '5px' }} />
                {office.address}
              </Typography>

              <Typography variant="headline" style={{ marginTop: '5px', fontSize: '0.85rem', lineHeight: '1.5rem', display: 'flex' }}>
                <LaunchIcon style={{ color: '#ff1744', marginRight: '5px' }} />
                <a href={office.url} target='_blank'>www.bazabiur.pl</a>
              </Typography>

              {contacts && (
                <Fragment>
                <Typography variant="headline" style={{ marginTop: '50px' }}>Team</Typography>
                  <List>
                    {contacts.map((contact, index) => (
                      <ListItem key={index} disableGutters={true} style={{ padding: '0 0 8px' }}>
                        {contact.avatar !== ''
                          ? <Avatar alt={contact.initials} src={`/static/images/avatars/${contact.avatar}`} />
                          : <Avatar style={{backgroundColor: red[500]}}>{contact.initials}</Avatar>}
                        <ListItemText primary={contact.fullName} style={{ fontSize: '0.9rem' }} />
                      </ListItem>
                    ))}
                  </List>
                </Fragment>
              )}

              {office.lastUpdate && (
                <Typography variant="headline" style={{ marginTop: '15px', fontSize: '0.75rem', lineHeight: '1.5rem', display: 'flex' }}>
                  <UpdateIcon style={{ marginRight: '5px' }} />
                  Last update: {office.lastUpdate}
                </Typography>
              )}
            </Grid>
          </Grid>

          <div className={classes.tabContainer}>
            <Tabs
              value={tab}
              onChange={this.handleTabToggle}
              classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator, scrollButtons: classes.tabsScrollButtons }}
              scrollable
              scrollButtons="auto"
            >
              <Tab
                disableRipple
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label="Building data"
              />
              {<Tab
                disableRipple
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label="Pricing"
              />}
              <Tab
                disableRipple
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label="Gallery"
              />
              <Tab
                disableRipple
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label="Enquiries"
              />
            </Tabs>

            {tab === 0 &&
              <OfficeDataTab officeId={id} data={office} />
            }
            {tab === 1 &&
              <PricingTab officeId={id} data={packets} />
            }
            {tab === 2 &&
              <GalleryTab officeId={id} photos={office.photos} newPhotos={office.update.hasOwnProperty('newPhotos') ? office.update.newPhotos : []} />
            }
            {tab === 3 &&
              <CardContent>
                {officeEnquiries.length > 0 && (
                  <div className="table-responsive">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Company</TableCell>
                          <TableCell numeric>Size</TableCell>
                          <TableCell numeric>Commencement date</TableCell>
                          <TableCell numeric>Received</TableCell>
                          <TableCell numeric>Status</TableCell>
                          {/*<TableCell numeric>Current progress</TableCell>*/}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        { officeEnquiries.map(e => {
                          //const color = statusColor[e.statusId - 1]

                          return (
                            <TableRow key={e.id}>
                              <TableCell component="th" scope="row">
                                <Link to={`/enquiry/${e.id}`}>
                                  {e.name}
                                </Link>
                              </TableCell>
                              <TableCell numeric>
                                {e.numberOfEmployees
                                  ? <Fragment>
                                      <span style={{ verticalAlign: 'middle' }}>{e.space}</span>
                                      <PersonIcon style={{ fontSize: 13, verticalAlign: 'middle' }} />
                                    </Fragment>
                                  : e.space
                                }
                              </TableCell>
                              <TableCell numeric>{e.commencementDate}</TableCell>
                              <TableCell numeric>{e.receivedOn}</TableCell>
                              <TableCell numeric>{e.status}</TableCell>
                            </TableRow>)
                          })
                        }
                      </TableBody>
                    </Table>
                  </div>
                )}
                {officeEnquiries.length === 0 && (
                  <Typography gutterBottom>There are no enquiries for this building yet.</Typography>
                )}
              </CardContent>
            }
          </div>
        </div>
      </div>
		)
	}
}

OfficePage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const arrayToObject = (array) =>
  array.reduce(
    (obj, item, index) => {
      obj[index] = item
      return obj
    }, {}
  )

function mapStateToProps ({ authedUser, offices, enquiries }, props) {
  const { id } = props.match.params
  const officeEnquiriesIds = offices[id].enquiries
  const officeEnquiries = Object.values(enquiries).filter((e) => (officeEnquiriesIds.includes(e.id))).map((enquiry) => formatEnquiry(enquiry))
  const sortedEnquiries = officeEnquiries.sort((a,b) => b.parsedReceivedDate - a.parsedReceivedDate)
  const packets = offices[id].packets

  return {
    id,
    user: authedUser.name,
    userId: authedUser.id,
    accountId: authedUser.accountId,
    office: offices[id],
    officeEnquiries: sortedEnquiries,
    packets: packets
  }
}

export default connect(mapStateToProps)(withRouter(withStyles(OfficePageStyles)(OfficePage)))


// WEBPACK FOOTER //
// ./src/components/Offices/OfficePage.js